import { memo, useCallback, useMemo } from 'react';

import { DownloadsRow } from '~/components/ShareModal/components/VersionsAndDownloadingSection/DownloadsRow';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';
import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { canExportAsset } from '~/utils/permissions/assetPermissions';
import { getDownloadPermissionMode } from '~/utils/shortUrl/buildDownloadPermissionShortUrlUpdate';

/** Create-mode smart leaf: allow-downloading segmented row. Writes draft state, no per-change analytics. */
export const CreateShowcaseSettingsDownloadsRow = memo(() => {
  const { shortUrlProps, isSaving, updateDownloadPermissions } = useShowcaseModal();
  const { data: workspacePermissions } = useCurrentWorkspacePermissionsContext();

  const workspaceCanDownload = useMemo(() => canExportAsset(workspacePermissions), [workspacePermissions]);

  const handleDownloadsChange = useCallback(
    ({ canViewOriginal, hideDownloadAll }: { canViewOriginal: boolean; hideDownloadAll: boolean }) => {
      updateDownloadPermissions(getDownloadPermissionMode(canViewOriginal, hideDownloadAll));
    },
    [updateDownloadPermissions],
  );

  return (
    <DownloadsRow
      canViewOriginal={shortUrlProps.permissions.asset.canViewOriginal}
      data-testid="DOWNLOADS_SEGMENTED_CONTROL"
      hideDownloadAll={shortUrlProps.presentationSettings?.hideDownloadAll}
      isLoading={isSaving}
      onChange={handleDownloadsChange}
      workspaceCanDownload={workspaceCanDownload}
    />
  );
});

CreateShowcaseSettingsDownloadsRow.displayName = 'CreateShowcaseSettingsDownloadsRow';
